/* eslint-disable react/prop-types */
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { withRouter } from 'react-router-dom';

const CustomTableFilter = ({ filter, setFilter }) => {
  return (
    <span className="filter-table">
      <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1rem' }} />
      <input value={filter || ''} onChange={(e) => setFilter(e.target.value)} />
    </span>
  );
};

export default withRouter(CustomTableFilter);
